import { Divider, Fade, Modal, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { FC, useState } from "react";
import NavBar from "./NavBar";
import { Link } from "gatsby";
import { NAV_BAR_MENU_PAGES } from "../constants";

interface MenuOptionProps {
  title: string;
  path: string;
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  closeMenu: () => void;
  withDivider?: boolean;
}

const MenuOption: FC<MenuOptionProps> = ({
  title,
  path,
  withDivider,
  closeMenu,
  onClick,
}) => {
  const isActive = window.location.pathname === path;

  return (
    <>
      <Link
        color="inherit"
        to={path}
        style={{
          width: "100%",
        }}
        onClick={(e) => {
          closeMenu();
          onClick && onClick(e);
        }}
      >
        <Box>
          <Typography
            variant="h5"
            sx={{
              m: 0,
              transition: "color 0.3s ease-in-out",
              color: isActive ? "text.primary" : "text.secondary",
            }}
          >
            {title}
          </Typography>
        </Box>
      </Link>
      {withDivider && <Divider sx={{ my: 2 }} />}
    </>
  );
};

interface NavProps {
  inverted?: boolean;
}

const Nav: React.FC<NavProps> = (props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { inverted } = props;

  const toggleMenu = () => setIsMenuOpen((prevState) => !prevState);

  const toggleWithDelay = () => {
    setTimeout(() => {
      setIsMenuOpen(false);
    }, 200);
  };

  return (
    <>
      <NavBar inverted={inverted} menuOpen={false} toggleMenu={toggleMenu} />
      <Modal
        aria-labelledby="Menu"
        aria-describedby="Navigation menu"
        open={isMenuOpen}
        onClose={toggleWithDelay}
        onClick={toggleWithDelay}
        closeAfterTransition
        key={`modal-${isMenuOpen}`}
      >
        <Fade in={isMenuOpen} timeout={300}>
          <Box
            sx={{
              width: "100%",
              height: "100vh",
              backgroundColor: "white",
              position: "relative",
              color: "text.primary",
            }}
          >
            <NavBar menuOpen toggleMenu={() => setIsMenuOpen(false)} />
            <Stack
              sx={{
                width: "100%",
                height: "100%",
                px: { xs: 1.5, sm: 3, md: 6 },
                paddingTop: { xs: "72px", sm: "80px", md: "83px" },
              }}
              justifyContent="flex-start"
              overflow="auto"
            >
              <Box sx={{ width: "100%", pt: 2 }}>
                {NAV_BAR_MENU_PAGES.map((pageData, index, arr) => (
                  <MenuOption
                    key={pageData.path}
                    title={pageData.name}
                    path={pageData.path}
                    withDivider={arr.length - 1 !== index}
                    closeMenu={() => setIsMenuOpen(false)}
                    onClick={pageData.onClick}
                  />
                ))}
              </Box>
            </Stack>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};

export default Nav;
